import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import FaqSection from "./FaqSection";

import BusinessCard from "./BusinessCard";
import { useMemo, useState } from "react";



import {
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AboutSplitCard from "../../components/subComponents/AboutSplitCard";
import { ConnectCard1 } from "../../components/subComponents/ConnectCard1";
import ConnectCard2 from "../../components/subComponents/ConnectCard2";
import ConnectBanner from "../../components/subComponents/ConnectBanner";
import { saffronRout } from "../../Url";

const safeArray = (v) => (Array.isArray(v) ? v : []);

const addPosition = (arr) =>
  safeArray(arr).map((item, i) => ({ ...item, position: i }));



const SiteHomePageData = ({
  selectedCountry,
  selectedCategory,
  selectedLanguage,
  selectedState,
  selectedCity,
  api = "https://thehindutoday.com",
}) => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [activeKey, setActiveKey] = useState(null); // which section is active
  const location = useLocation();

  const {
    data: profiledata = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: [
      "profiledata",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-people?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: featuredprofiledata = [] } = useQuery({
    queryKey: [
      "featuredprofiledata",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_popular", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-people?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: featureListData = [] } = useQuery({
    queryKey: [
      "featureListData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-listing?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: apiblogsData = [] } = useQuery({
    queryKey: [
      "apiblogsData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-blogs?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: faqData = [] } = useQuery({
    queryKey: [
      "faqData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      const res = await axios.get(
        `${api}/api/v1/public/faqs?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: menuData = [] } = useQuery({
    queryKey: [
      "menuData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      const res = await axios.get(
        `${api}/api/v1/public/menu?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const { data: aboutData = [] } = useQuery({
    queryKey: [
      "aboutData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      const res = await axios.get(
        `${api}/api/v1/public/about-us?${params.toString()}`,
      );
      return res.data;
    },
    retry: false,
    staleTime: 1000 * 60 * 60,
  });

  const popularCats = useMemo(
    () => addPosition(profiledata?.data),
    [profiledata?.data],
  );

  const featuredCats = useMemo(
    () => addPosition(featuredprofiledata?.data),
    [featuredprofiledata?.data],
  );

  const allListings = useMemo(
    () => addPosition(featureListData?.data),
    [featureListData?.data],
  );

  const blogsData = useMemo(
    () => addPosition(apiblogsData?.data),
    [apiblogsData?.data],
  );

  const faqSectionData = useMemo(
    () => addPosition(faqData?.data?.faqs),
    [faqData?.data],
  );

  const navigate = useNavigate();
  const handleArticleClick = (item, key, type) => {
    setActiveKey(key);
    setSelectedArticle({
      slug: item?.slug,
      position: item?.position,
      type,
    });

    window.scrollTo(0, 0);

    const itemLabel = item?.title || item?.name || "Details";

    // ✅ Build filters + add section in URL (IMPORTANT)
    const params = new URLSearchParams(location.search);

    // keep only filters (same logic as buildSafeSearch)
    const next = new URLSearchParams();
    ["country", "state", "city", "language", "category"].forEach((k) => {
      const v = params.get(k);
      if (v) next.set(k, v);
    });

    next.set("section", key); // ✅ THIS was missing

    navigate(
      {
        pathname: `${saffronRout}/details/${type}/${item.slug}`,
        search: `?${next.toString()}`,
      },
      {
        state: {
          sectionKey: key,
          position: item.position,
          label: itemLabel,
        },
      },
    );
  };

  return (
    <>
      {!selectedArticle && (
        <>
          <ConnectBanner
            selectedCategory={selectedCategory}
            selectedCountry={selectedCountry}
            selectedLanguage={selectedLanguage}
            selectedState={selectedState}
            selectedCity={selectedCity}
          />
          <section className=" px-1 md:px-5 lg:px-10 bg-gradient-to-b from-[#fff0e4] to-[#fff0e4] space-y-3">
            {/* Popular Profiles */}
            <div className="!mt-6">

              {popularCats?.length > 0 && <SectionWrapper
                title={menuData?.data?.home_items[0]?.label}
                viewMoreLink={`${saffronRout}/profile`}
                location={location}
                state_data={'is_popular'}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
                  {(popularCats ?? []).map((item) => (
                    <ConnectCard2
                      key={item.id}
                      data={item}
                      onArticleClick={() =>
                        handleArticleClick(item, "popularProfiles", "people")
                      }
                    />
                  ))}
                </div>
              </SectionWrapper>}
            </div>

            {/* Featured Profiles */}
            <div>
             {featuredCats?.length > 0 && <SectionWrapper
                title={menuData?.data?.home_items[1]?.label}
                viewMoreLink={`${saffronRout}/profile`}
                location={location}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
                  {(featuredCats ?? []).map((item) => (
                    <ConnectCard2
                      key={item.id}
                      data={item}
                      onArticleClick={() =>
                        handleArticleClick(item, "featuredProfiles", "people")
                      }
                    />
                  ))}
                </div>
              </SectionWrapper>}
            </div>

            {/* Featured Sponsored Feature */}
            <div>
            {allListings?.length > 0 &&  <SectionWrapper
                title={menuData?.data?.home_items[2]?.label}
                viewMoreLink={`${saffronRout}/business`}
                location={location}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
                  {(allListings ?? []).map((item) => (
                    <BusinessCard
                      key={item.id}
                      data={item}
                      onArticleClick={() =>
                        handleArticleClick(item, "listings", "listing")
                      }
                    />
                  ))}
                </div>
              </SectionWrapper>}
            </div>

            {/* Blogs */}
            <div>
              {blogsData?.length > 0 && (
                <SectionWrapper
                  title={menuData?.data?.home_items[3]?.label}
                  viewMoreLink={`${saffronRout}/blog`}
                  location={location}
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
                    {blogsData.map((item) => (
                      <ConnectCard1
                        key={item.id}
                        item={item}
                        onArticleClick={() =>
                          handleArticleClick(item, "blogs", "blog")
                        }
                        imgH=" h-[260px]"
                        objimg="object-fill"
                      />
                    ))}
                  </div>
                </SectionWrapper>
              )}
            </div>

            {/* FAQ */}
         
              <div className=" !mb-4">
                {faqSectionData?.length > 0 && (
                  <SectionWrapper
                    title={menuData?.data?.home_items[4]?.label}
                    location={location}
                    viewMoreLink={`${saffronRout}/faq`}
                  >
                    <FaqSection
                      faqs={faqSectionData}
                      labelData={menuData?.data?.home_items[4]?.label}
                    />
                  </SectionWrapper>
                )}
              </div>
      
          </section>
          

          <SectionWrapper
            title={menuData?.data?.home_items[5]?.label}
            location={location}
            bg={"#ffebda"}
          >
            <div className="px-1  lg:px-10">
              <AboutSplitCard data={aboutData?.data?.about_us} />
            </div>
          </SectionWrapper>
         
        </>
      )}
    </>
  );
};

const keepKeys = ["country", "state", "city", "language", "category"];

const buildSafeSearchFromLocation = (location, sectionKey) => {
  const current = new URLSearchParams(location?.search);
  const next = new URLSearchParams();

  keepKeys.forEach((k) => {
    const v = current.get(k);
    if (v) next.set(k, v);
  });

  if (sectionKey) next.set("section", sectionKey);

  return next.toString() ? `?${next.toString()}` : "";
};

const SectionWrapper = ({ title, children, viewMoreLink, location, bg ,state_data}) => {
  return (
    <section className="text-center " style={{ backgroundColor: bg }}>
      <div className="text-center  pt-6 mb-4">
        <h2 className="text-2xl sm:text-3xl  font-medium text-[#9d2e43]">
          {title}
        </h2>
        <div className="w-20 h-1 bg-orange-500 mx-auto mt-3 rounded-full"></div>
      </div>

      {children}
      {viewMoreLink && (
        <div className="mt-4 flex justify-center">
          <NavLink
            to={{
              pathname: viewMoreLink,
              search: buildSafeSearchFromLocation(location, state_data || "features"),
            }}
            state={{ fromSection: state_data || "features" }}
            className="
        group inline-flex items-center gap-2
        px-6 py-2.5
        rounded-full
        border border-orange-500
        text-orange-600 font-semibold
        transition-all duration-300
        hover:bg-orange-500 hover:text-white
        hover:shadow-lg hover:-translate-y-[1px]
      "
          >
            View More
            <span className="transition-transform group-hover:translate-x-1">
              →
            </span>
          </NavLink>
        </div>
      )}
    </section>
  );
};

export default SiteHomePageData;
